"use strict";

module.exports = function(angular, moduleName) {
  angular
    .module(moduleName)
    .controller(
      "HeaderController",
      require("app/presentation/controllers/HeaderController")
    )
    .controller(
      "HomeController",
      require("app/presentation/controllers/HomeController")
    )
    .controller(
      "LaunchController",
      require("app/presentation/controllers/LaunchController")
    )
    .controller(
      "MultiFactorAuthenticationController",
      require("app/presentation/controllers/MultiFactorAuthenticationController")
    )
    .controller(
      "RtGlobalSettingsController",
      require("app/presentation/controllers/RtGlobalSettingsController")
    )
    .controller(
      "WindowController",
      require("app/presentation/controllers/WindowController")
    )
    .controller(
      "ErrorMessageController",
      require("app/presentation/controllers/ErrorMessageController")
    )
    .filter(
      "trustAsResourceUrl",
      require("app/presentation/filters/trustAsResourceUrl")
    )
    .service("windowTitle", require("app/presentation/services/windowTitle"));
};



// WEBPACK FOOTER //
// ./app/presentation/presentationIndex.js